import React from 'react';
import { IconProps } from '.';

const SvgArrowDirectionUp = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m12 2.942 7.529 7.485-1.058 1.064-5.721-5.688V21h-1.5V5.803l-5.721 5.688-1.058-1.064L12 2.942Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowDirectionUp;
